import { useState } from "react";

import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { checkSupabaseHealth, type SupabaseHealthResult } from "@/lib/supabase/health";

export function SupabaseConnectionCard({ className }: { className?: string }) {
  const [result, setResult] = useState<SupabaseHealthResult | null>(null);
  const [loading, setLoading] = useState(false);

  const run = async () => {
    setLoading(true);
    try {
      const res = await checkSupabaseHealth();
      setResult(res);
    } catch (err) {
      const msg = err instanceof Error ? err.message : "Bağlantı kontrol edilemedi";
      setResult({ ok: false, status: 0, message: msg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className={className ? `p-5 ${className}` : "p-5"}>
      <div className="flex items-start justify-between gap-4">
        <div>
          <div className="font-display text-lg font-semibold tracking-tight">Veri tabanı</div>
          <div className="mt-1 text-sm text-muted-foreground">
            Supabase bağlantı kontrolü.
            {result ? ` Durum: ${result.ok ? "Bağlı" : "Sorun"} (${result.status || "-"})` : ""}
          </div>
        </div>
        <Button
          type="button"
          variant="outline"
          className="rounded-full"
          onClick={run}
          disabled={loading}
        >
          {loading ? "Kontrol ediliyor" : "Kontrol et"}
        </Button>
      </div>
      {result ? (
        <div className="mt-4 rounded-xl border bg-muted/30 px-4 py-3 text-sm text-muted-foreground">
          {result.message}
        </div>
      ) : null}
    </Card>
  );
}
